import { SPELL_ID } from '../ids/spell-id'
import { MODIFIER_ID } from '../ids/modifier-id'
import { TALENT_ID } from '../ids/talent-id'
import { PRIEST_TALENTS } from '../talents/priest'
import { SpellMap } from 'web/data/models'
import { copyTalentPropsToSpell } from 'web/data/core-data'

export const PRIEST_SPELLS: SpellMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Holy Priest
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.PRIEST.HOLY.DIVINE_HYMN]: {
        id: SPELL_ID.PRIEST.HOLY.DIVINE_HYMN,
        talentId: undefined,

        name: "Divine Hymn",
        shortName: "Hymn",

        cooldown: 180,
        affectedByModifierIds: [MODIFIER_ID.ESSENCE_VOP],

        game_id: 64843,
        icon_name: "spell_holy_divinehymn",
    },

    [SPELL_ID.PRIEST.HOLY.SALVATION]: {
        id: SPELL_ID.PRIEST.HOLY.SALVATION,
        cooldown: 720,
        affectedByModifierIds: [],

        ...copyTalentPropsToSpell(PRIEST_TALENTS[TALENT_ID.PRIEST.HOLY.SALVATION])
    },

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Disc Priest
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.PRIEST.DISC.RAPTURE]: {
        id: SPELL_ID.PRIEST.DISC.RAPTURE,
        talentId: undefined,

        name: "Rapture",
        shortName: "Rapt",

        cooldown: 90,
        affectedByModifierIds: [],

        game_id: 47536,
        icon_name: "spell_holy_rapture",
    },

    [SPELL_ID.PRIEST.DISC.BARRIER]: {
        id: SPELL_ID.PRIEST.DISC.BARRIER,
        talentId: undefined,

        name: "Power Word: Barrier",
        shortName: "PW:B",

        cooldown: 180,
        affectedByModifierIds: [],

        game_id: 62618,
        icon_name: "spell_holy_powerwordbarrier",
    },

    [SPELL_ID.PRIEST.DISC.SHADOWFIEND]: {
        id: SPELL_ID.PRIEST.DISC.SHADOWFIEND,
        talentId: undefined,

        name: "Shadowfiend",
        shortName: "Fiend",

        cooldown: 180,
        affectedByModifierIds: [MODIFIER_ID.ESSENCE_VOP],

        game_id: 34433,
        icon_name: "spell_shadow_shadowfiend",

        replacedByTalentId: TALENT_ID.PRIEST.DISC.MINDBENDER,
    },

    [SPELL_ID.PRIEST.DISC.MINDBENDER]: {
        id: SPELL_ID.PRIEST.DISC.MINDBENDER,
        cooldown: 60,
        affectedByModifierIds: [MODIFIER_ID.ESSENCE_VOP],

        ...copyTalentPropsToSpell(PRIEST_TALENTS[TALENT_ID.PRIEST.DISC.MINDBENDER])
    },

    [SPELL_ID.PRIEST.DISC.EVANGELISM]: {
        id: SPELL_ID.PRIEST.DISC.EVANGELISM,
        cooldown: 90,
        affectedByModifierIds: [],

        ...copyTalentPropsToSpell(PRIEST_TALENTS[TALENT_ID.PRIEST.DISC.EVANGELISM])
    },

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Shadow Priest
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.PRIEST.SHADOW.VAMPIRIC_EMBRACE]: {
        id: SPELL_ID.PRIEST.SHADOW.VAMPIRIC_EMBRACE,
        talentId: undefined,

        name: "Vampiric Embrace",
        shortName: "Vamp",

        cooldown: 120,
        affectedByModifierIds: [],

        game_id: 15286,
        icon_name: "spell_shadow_unsummonbuilding",
    },

}
